import { InventoryCategory } from '../models/InventoryCategory';
import { InventoryRecap } from '../models/InventoryRecap';

export type InventoryElements = {
  keyStores: InventoryCategory | null;
  hashFunctions: InventoryCategory | null;
  mac: InventoryCategory | null;
  asymmetricAlgorithms: InventoryCategory | null;
  symmetricAlgorithms: InventoryCategory | null;
  operations: InventoryCategory | null;
  keys: InventoryCategory[] | null;
};

const KEY_STORE_INVENTORY_NAME = 'Key Store';

const HASH_FUNCTIONS_INVENTORY_NAME = 'Hash Functions';

const MAC_INVENTORY_NAME = 'MAC';

const SYMMETRIC_ALGORITHMS_INVENTORY_NAME = 'Symmetric Algorithms';

const ASYMMETRIC_ALGORITHMS_INVENTORY_NAME = 'Asymmetric Algorithms';

const OPERATIONS_INVENTORY_NAME = 'Operations';

export class InventoryDataExtractor {
  extractInventoryElements(inventory: InventoryRecap | null): InventoryElements {
    const elements: InventoryElements = {
      keyStores: null,
      hashFunctions: null,
      mac: null,
      asymmetricAlgorithms: null,
      symmetricAlgorithms: null,
      operations: null,
      keys: null,
    };

    if (inventory === null) {
      return elements;
    }

    elements.keyStores = this.extractByName(inventory.getKeystores(), KEY_STORE_INVENTORY_NAME);
    elements.hashFunctions = this.extractByName(inventory.getAlgorithms(), HASH_FUNCTIONS_INVENTORY_NAME);
    elements.mac = this.extractByName(inventory.getAlgorithms(), MAC_INVENTORY_NAME);
    elements.asymmetricAlgorithms = this.extractByName(inventory.getAlgorithms(), ASYMMETRIC_ALGORITHMS_INVENTORY_NAME);
    elements.symmetricAlgorithms = this.extractByName(inventory.getAlgorithms(), SYMMETRIC_ALGORITHMS_INVENTORY_NAME);
    elements.operations = this.extractByName(inventory.getOperations(), OPERATIONS_INVENTORY_NAME);
    elements.keys = inventory.getKeys();

    return elements;
  }

  private extractByName(categories: InventoryCategory[], name: string): InventoryCategory | null {
    return categories.find((category) => category.getName() === name) ?? null;
  }
}
